import { AfterViewInit, Component, Input, OnChanges, OnDestroy, SimpleChanges } from "@angular/core";
import { Subscription } from "rxjs";
import { VTableComponent } from "../../v-table.component";
import "./table-summary-box.component.scss";

export type TableSummaryCalculatorFunction<T = any, M = any> = (item: T, allItems: T[], model?: M) => number;

@Component({
    selector: "table-summary-box",
    template: require("./table-summary-box.component.html")
})
export class TableSummaryBox implements OnChanges, OnDestroy, AfterViewInit {
    @Input() table: VTableComponent;
    @Input() calculator: TableSummaryCalculatorFunction;
    @Input() title: string;
    @Input() model: any;

    @Input() valuePrefix: string;

    // ---

    count: number;
    rowChangeSubscription = new Subscription();

    constructor() {
    }

    ngAfterViewInit() {
        if (!this.table) {
            console.error("table-summary-box: No table specified");
        }

        if (this.table && this.table.tableRows) {
            this.update();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["table"] && this.table) {

            this.clearSubscriptions();

            this.rowChangeSubscription = this.table.tableDisplayRowsChange.subscribe(() => {
                this.update();
            });
        }
    }

    ngOnDestroy() {
        this.clearSubscriptions();
    }

    // ---

    private update() {
        if (!this.table || !this.calculator) {
            console.error("TableSummaryBox: Cannot update aggregator, no rows or calculator function");
            return;
        }

        var rows = this.table.table?.displayRows;

        if (!rows) {
            return;
        }

        this.count = rows.reduce((x, y) => x + this.calculator(y.data, rows, this.model), 0);
    }

    private clearSubscriptions() {
        if (!this.rowChangeSubscription) {
            return;
        }

        this.rowChangeSubscription.unsubscribe();
        this.rowChangeSubscription = null;
    }
}
